import {MainLayout} from "../components/layouts/MainLayout.tsx";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import ContactForm from "../components/forms/ContactForm.tsx";

const ContactPage = () => {
    return (
        <MainLayout>
            <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}>
                <div className={"mx-2 md:mx-4 pt-16 md:pt-4 mb-4 flex-grow"}>
                    <h1 className={"text-3xl font-bold tracking-wide"}>Formularz kontaktowy</h1>
                    <div className={"my-6 mt-4 h-0.5 rounded-full w-28 bg-[#008dd2]"}/>
                    <div className={"bg-neutral-900 p-6 md:p-10 max-w-lg shadow-3xl rounded-3xl"}>
                        <ContactForm/>
                    </div>
                </div>
            </GoogleReCaptchaProvider>
        </MainLayout>
    );
};

export default ContactPage;